import React, { useMemo, useState, useCallback, useEffect } from 'react'
import debounce from 'lodash/debounce'

import { useTranslation } from '../../contexts/I18nContext'
import NoSleep from '../../helpers/no-sleep'
import { COLORS } from '../../styles'

import Styled from './PreventSleep.styled'

const PreventSleep = ({
  children,
  className,
  floatingButton,
  floatingButtonDisplayScrollTop,
  tagName,
}) => {
  const { t } = useTranslation()

  // Memoize NoSleep
  const noSleep = useMemo(() => new NoSleep(), [])

  // Detect button click state
  const [buttonClicked, setButtonClicked] = useState(false)

  // Disable sleep must be wrapped in a user input event handler (onClick)
  const enableNoSleepByButtonClick = useCallback(() => {
    noSleep.enable()
    setButtonClicked(true)
  }, [noSleep, setButtonClicked])
  const disableNoSleepByButtonClick = useCallback(() => {
    noSleep.disable()
    setButtonClicked(false)
  }, [noSleep, setButtonClicked])

  // Display/hide floating button according a "scrollY" offset
  const [displayButton, setDisplayButton] = useState(
    !floatingButtonDisplayScrollTop,
  )
  // eslint-disable-next-line react-hooks/exhaustive-deps
  const handleScroll = useCallback(
    debounce(() => {
      if (typeof window === 'undefined' || !floatingButtonDisplayScrollTop) {
        return
      }
      const { scrollY } = window
      if (scrollY > floatingButtonDisplayScrollTop && !displayButton) {
        setDisplayButton(true)
      } else if (scrollY < floatingButtonDisplayScrollTop && displayButton) {
        setDisplayButton(false)
      }
    }, 200),
    [floatingButtonDisplayScrollTop, displayButton],
  )
  useEffect(() => {
    if (typeof window === 'undefined') {
      return
    }
    window.addEventListener('scroll', handleScroll)
    return () => {
      window.removeEventListener('scroll', handleScroll)
    }
  }, [handleScroll])

  return (
    <Styled className={className} tagName={tagName}>
      {children}
      {floatingButton ? (
        <Styled.floatingButton
          onClick={
            buttonClicked
              ? disableNoSleepByButtonClick
              : enableNoSleepByButtonClick
          }
          buttonClicked={buttonClicked}
          hideButton={!displayButton}
        >
          <Styled.floatingButtonIcon
            name="zz-16"
            height={16}
            width={16}
            fill={COLORS.white}
          />
          <Styled.floatingButtonText>
            {buttonClicked ? t('AUTO_LOCK_ENABLED') : t('AUTO_LOCK_DISABLED')}
          </Styled.floatingButtonText>
        </Styled.floatingButton>
      ) : null}
    </Styled>
  )
}

PreventSleep.defaultProps = {
  tagName: 'div',
  floatingButton: true,
}

export default PreventSleep
